import { ERROR_MESSAGES } from '../constants/messages'
import { isValidMnemonic } from './wallet'

export function getPasswordErrors({ password, repeatPassword }) {
  const passwordMessage = password.length < 4 ? ERROR_MESSAGES.INVALID_PASSWORD : ''
  const repeatPasswordMessage = checkPasswords(password, repeatPassword)
  return {
    password: passwordMessage,
    repeatPassword: repeatPasswordMessage
  }
}

function checkPasswords(password, repeatPassword) {
  if (repeatPassword.length === 0) {
    return ERROR_MESSAGES.INVALID_PASSWORD
  } else if (password !== repeatPassword) {
    return ERROR_MESSAGES.MISTYPED_PASSWORD
  } else if (!password) {
    return ERROR_MESSAGES.INVALID_PASSWORD
  }

  return ''
}


export function getMnemonicErrors({ mnemonic, fromScan }) {
  const mnemonicMessage = checkMnemonic(mnemonic, fromScan)
  return {
    mnemonic: mnemonicMessage
  }
}

function checkMnemonic(mnemonic, fromScan) {
  if (!isValidMnemonic(mnemonic)) {
    return fromScan ? ERROR_MESSAGES.INVALID_MNEMONIC_QR : ERROR_MESSAGES.INVALID_MNEMONIC_QR
  }

  return ''
}


// WEBPACK FOOTER //
// ./src/util/errors.js